import React, { useState } from 'react';
import '../css/Navbar.css'; // O puedes agregar el CSS en App.css si prefieres

function Navbar() {
  const [menuAbierto, setMenuAbierto] = useState(false);

  const toggleMenu = () => {
    setMenuAbierto(!menuAbierto);
  };

  return (
    
    <div className="main-header" >
      
      <nav className="navbar">
        <div className="navbar-logo">
          <img src="/images/logoChilesSF.png" alt="CHILEROS DON RENE" />
          <span>CHILEROS DON RENE </span>
        </div>

        {/* Botón hamburguesa */}
        <button className="menu-toggle" onClick={toggleMenu}>
          ☰
        </button>

        <ul className={`navbar-links ${menuAbierto ? 'active' : ''}`}>
          <li><a href="#inicio">Inicio</a></li>
          <li><a href="#nosostros">Nosotros</a></li>
          <li><a href="#productos">Productos</a></li>
          <li><a href="#Galeria">Galeria</a></li>
          <li><a href="#mision">Misión, Visión y Valores</a></li>
          <li><a href="#contacto">Contacto</a></li>
        </ul>
      </nav>
     
    </div>
   
  );
}

export default Navbar;


